const getSearchResultCol = ({ search_type, searchResultCard }) => {

  const html = `
    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12">
      ${searchResultCard}
    </div>
  `;
  return html;

}

const numberFormatter = new Intl.NumberFormat('en-SG', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const renderNumericRange = (item, { min, max, prefix='', suffix='' }) => {
  if (!item) {
    return;
  }
  if (item[min] === null) {
    return `<div>ENQUIRE</div>`;
  }
  else if (item[min] === "SOLD OUT") {
    return `<div>SOLD OUT</div>`;
  }
  else if (item[min] === item[max]) {
    return `<div>${prefix}${numberFormatter.format(item[min])}${suffix}</div>`;
  }
  else if (item[min] && !item[max]) {
    return `<div>${prefix}${numberFormatter.format(item[min])}${suffix}</div>`;
  }
  else {
    return `<div>${prefix}${numberFormatter.format(item[min])}${suffix} - ${prefix}${numberFormatter.format(item[max])}${suffix}</div>`;
  }
}

const getSearchResultCard = ({ search_type, data }) => {

  // Keep for customisation
  return null;

  const renderImageOverlay = () => {
    let overlayBadges = [], overlayText = [];
    if (data.availability.includes(10)) {
      overlayText.push(`<div class="bg-danger p-2">100% SOLD</div>`);
    }
    let info = [];
    if (overlayText.length > 0) {
      info.push(`
        <div style="z-index:1;position:absolute;inset:0;background-color:rgba(0,0,0,0.5);"></div>
        <div style="z-index:2;position:absolute;inset:0;color:white;" class="h-100 d-flex flex-column align-items-center justify-content-center">
          ${overlayText.join("")}
        </div>
      `);
    }
    return `
      <div style="position:absolute;inset:0;">
        ${info.join("") || ""}
      </div>
    `;
  }

  const renderImage = () => {
    if (data.featured_media_url__medium_large) {
      return `<img class="card-img-top" loading="lazy" src=${data.featured_media_url__medium_large}>`;
    }
  }

  const renderTitle = () => {
    return data.project_name;
  }

  const renderBadges1 = () => {
    let info = [];
    if (data.property_type) {
      info.push(`<span class="rounded-0 border-0 text-dark fw-normal badge bg-light">${data.property_type}</span>`);
    }
    if (info.length > 0) {
      return `<div class="d-flex flex-row flex-wrap align-items-start gap-1">${info.join("")}</div>`;
    }
  }

  const renderBadges2 = () => {
    let info = [];
    if (data.location) {
      info.push(`<span class="rounded-0 border-0 text-dark fw-normal badge bg-light">${data.location}</span>`);
    }
    if (data.tenure) {
      info.push(`<span class="rounded-0 border-0 text-dark fw-normal badge bg-light">${data.tenure}</span>`);
    }
    if (data.expected_top_year) {
      info.push(`<span class="rounded-0 border-0 text-dark fw-normal badge bg-light">${data.expected_top_year}</span>`);
    }
    if (info.length > 0) {
      return `<div class="d-flex flex-row flex-wrap align-items-start gap-1">${info.join("")}</div>`;
    }
  }

  data.property_prices = data.property_prices || [];

  const totalUnits = data.property_prices.reduce((carry, item) => carry + item.NoOfUnits, 0);
  const totalUnitsSold = data.property_prices.reduce((carry, item) => carry + item.NoOfUnitsSold, 0);
  const percSold = Math.round((totalUnitsSold / totalUnits)*100);
  const isResidential = data.property_prices.filter(item => item.Bedrooms > 0).length || 0;
  const unitTypes = data.property_prices.map(item => item.key);

  const renderPercSold = () => {
    if (percSold >= 0) {
      return `
      <div class="donut-wrap" style="--size: 30px; --percentage: ${percSold};">
        <div class="donut-ring" aria-hidden="true"></div>
        <div class="donut-label">${percSold}%</div>
      </div>
      `;
    }
  }

  const renderPrices = () => {
    let priceLines = [];
    for (const key of unitTypes) {
      const priceItem = data.property_prices.find(item => item.key === key);
      const priceItemPercSold = Math.round((priceItem?.NoOfUnitsSold / priceItem?.NoOfUnits) * 100);
      const name = `${key}` + (key > 0 ? "BR" : "");
      const areaRange = renderNumericRange(priceItem, { min: "MinArea", max: "MaxArea", suffix: " sf" });
      const minPrice = renderNumericRange(priceItem, { min: "MinPrice", prefix: "$" });
      priceLines.push(`
        <div>
          <div class="d-flex flex-row justify-content-between small">
            <div class="d-flex flex-row gap-1">
              <div>${name}</div>
            </div>
            <div class="d-flex flex-row gap-1">
              <span class="text-dark fw-normal badge bg-light">
                <div>${areaRange}</div>
              </span>
              <div>
                <div>${minPrice}</div>
              </div>
            </div>
          </div>
          <div class="progress-line" style="--percentage: ${priceItemPercSold};"></div>
        </div>
      `);
    }
    return `${priceLines.join("")}`;
  }

  const html = `
  <div class="h-100 cursor-pointer rounded-4 border-0 shadow card">
    <div class="position-relative">
      ${renderImageOverlay() || ""}
      ${renderImage() || ""}
    </div>
    <div class="d-flex flex-column gap-1 card-body">
      <div class="d-flex flex-row justify-content-between gap-1">
        <div class="d-flex flex-column gap-1">
          <div class="project_title fw-bold">${renderTitle() || ""}</div>
          ${renderBadges1() || ""}
          ${renderBadges2() || ""}
        </div>
        <div class="d-flex flex-column" style="min-width: 30px;">
          ${renderPercSold() || ""}
        </div>
      </div>
      <div class="d-flex flex-column gap-1 property_prices">
        ${renderPrices() || ""}
      </div>
    </div>
  </div>
  `;

  return html;

}

const getSearchResultMapFeatureProps = ({ data }) => {

  return {
    type: 'marker',
  }

}

const getSearchResultColProps = ({ data }) => {

  return {
    xl: 3,
    lg: 4,
    md: 4,
    sm: 6,
    xs: 12,
  }

}

const getSearchResultCardProps = ({ data, search_type }) => {

  switch (search_type) {
    case "map": {
      const onClick = () => {
        window.open(data.link, '_blank');
      }
      return {
        className: "cursor-pointer",
        onClick: onClick,
      }
    }
    default:
      const onClick = () => {
        window.location.href = data.link;
      }
      return {
        className: "h-100 cursor-pointer rounded-4 border-0 shadow",
        onClick: onClick,
      }
      break;
  }

}

export {
  getSearchResultCol, getSearchResultCard,
  getSearchResultColProps, getSearchResultCardProps, getSearchResultMapFeatureProps
};
